import React from 'react';
import { Div } from '../utils/styled';

type TCommonScreenProps = {
    Icon:
        | React.ComponentType<{
              fill: string;
          }>
        | React.FC;
    mainText?: string;
    uid?: string;
    color?: string;
};

export const CommonScreen = (props: TCommonScreenProps) => {
    const { mainText, color = '', uid } = props;
    return (
        <Div
            sx={{
                bottom: 0,
                left: 0,
                minWidth: '288px',
                overflow: 'auto',
                position: 'fixed',
                right: 0,
                top: 0,
            }}
            data-test={uid}
        >
            <Div
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100%',
                    width: '100%',
                    boxSizing: 'border-box',
                    flex: 1,
                    padding: '72px 24px 92px 24px',
                }}
            >
                <Div sx={{ width: '100%', maxWidth: '504px' }}>
                    <div>{props.Icon && <props.Icon fill={color} />}</div>
                    {mainText && (
                        <Div
                            sx={{
                                display: 'inline-block',
                                fontSize: '17px',
                                lineHeight: '24px',
                                marginTop: '24px',
                                '@media screen and (min-width: 1920px)': {
                                    fontSize: '20px',
                                    lineHeight: '32px',
                                },
                            }}
                        >
                            {mainText}
                        </Div>
                    )}
                </Div>
            </Div>
        </Div>
    );
};
